module.exports = __webpack_public_path__ + "img/long-term-cache/kutubee-logo.0d41b77d5739d8ffa589d7b0705bd9af.png";